export var FAST_JOIN = 'FAST_JOIN';
export var SUCCESS_FAST_JOIN = 'SUCCESS_FAST_JOIN';
export var FAILURE_FAST_JOIN = 'FAILURE_FAST_JOIN';
export var FAST_CONFIRM_PHONE = 'FAST_CONFIRM_PHONE';
export var SUCCESS_FAST_CONFIRM_PHONE = 'SUCCESS_FAST_CONFIRM_PHONE';
export var FAILURE_FAST_CONFIRM_PHONE = 'FAILURE_FAST_CONFIRM_PHONE';
export var ERROR_RESET = 'ERROR_RESET';
export var CLOSE_REGISTRATION_SUCCESS_MODAL = 'CLOSE_REGISTRATION_SUCCESS_MODAL';
export var CLOSE_CONFIRM_PHONE_MODAL = 'CLOSE_CONFIRM_PHONE_MODAL';
export var CLOSE_EMAIL_ACTIVATION_MODAL = 'CLOSE_EMAIL_ACTIVATION_MODAL';
export var CLOSE_THANK_YOU_MODAL = 'THANK_YOU_MODAL';
export var CLOSE_CONFIRM_PHONE_MODAL_SUCCESS = 'CLOSE_CONFIRM_PHONE_MODAL_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/auth/FastJoin.js